<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.HtmlToWord.title') }}</span>
      <span class="fmt-spacer"/>
      <span :class="['uc-chip',{on:showPreview}]" @click="showPreview=!showPreview">{{ $t('tool.HtmlToWord.preview') }}</span>
      <el-button size="small" plain icon="el-icon-star-off" @click="doAction('sample')">{{ $t("common.action.sample") }}</el-button>
      <el-button size="small" icon="el-icon-download" type="primary" @click="downloadWord">{{ $t('tool.HtmlToWord.download') }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doAction('copy')">{{ $t("common.action.copy") }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="doAction('clear')">{{ $t("common.action.clear") }}</el-button>
    </div>
    <el-input v-model="html" type="textarea" :rows="showPreview?10:18"
      :placeholder="$t('tool.HtmlToWord.phHtml')"
      class="fmt-textarea" style="min-height:200px"/>
    <div class="ht-preview" v-if="showPreview && html.trim()">
      <div class="ht-preview-title">{{ $t('tool.HtmlToWord.previewTitle') }}</div>
      <div v-html="html"/>
    </div>
    <div class="fmt-status-bar">
      <span v-if="html.trim()" class="fmt-hint">{{ $t('tool.HtmlToWord.hintChars', { n: html.length }) }}{{ showPreview ? $t('tool.HtmlToWord.hintPreviewMode') : '' }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.HtmlToWord.hintEmpty') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HtmlToWordTool',
  props: { config: { type: Object, default: () => ({}) } },
  data: function(){ return { html: '', showPreview: false } },
  methods: {
    doAction:function(action) {
      switch (action) {
        case 'sample':
          var t = this.$t('tool.HtmlToWord')
          this.html = '<h1 style="color:#333">'+t.sampleDocTitle+'</h1><p>A paragraph with <b>'+t.sampleBold+'</b> text and <i>'+t.sampleItalic+'</i> text.</p><table border="1" style="border-collapse:collapse;width:100%"><tr style="background:#f0f0f0"><td>'+t.sampleName+'</td><td>'+t.sampleAge+'</td></tr><tr><td>'+t.sampleNameVal+'</td><td>'+t.sampleAgeVal+'</td></tr></table>'
          break
        case 'copy': navigator.clipboard.writeText(this.html); this.$message.success(this.$t("common.status.copied")); break
        case 'clear': this.html = ''; break
      }
    },
    downloadWord:function() {
      var content = '<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>' + (this.html || '<p>'+this.$t('tool.HtmlToWord.emptyDoc')+'</p>') + '</body></html>'
      var blob = new Blob([content], { type: 'application/msword;charset=utf-8' })
      var url = URL.createObjectURL(blob); if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) { var file = new File([blob], 'document.doc', { type: 'application/msword' }); if (navigator.share) { navigator.share({ files: [file] }).catch(function() { window.open(url, '_blank') }) } else { window.open(url, '_blank') } } else { var a = document.createElement('a'); a.href = url; a.download = 'document.doc'; document.body.appendChild(a); a.click(); document.body.removeChild(a); setTimeout(function() { URL.revokeObjectURL(url) }, 3000) }
      this.$message.success(this.$t('tool.HtmlToWord.downloading'))
    }
  }
}
</script>

<style scoped>
.fmt-tool{display:flex;flex-direction:column;gap:12px;max-width:100%}

.fmt-toolbar{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.fmt-toolbar >>> .el-button + .el-button{margin-left:0}
.fmt-label{font-size:13px;font-weight:700;color:#1a1f36}
.fmt-spacer{flex:1}

.uc-chip{padding:5px 14px;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;color:#909399;background:#f0f2f5;transition:.12s;border:1px solid transparent}
.uc-chip:hover{color:#4e7cff}
.uc-chip.on{background:#e8f0fe;color:#4e7cff;border-color:#4e7cff}

.fmt-textarea >>> textarea{
  font-family:'JetBrains Mono','Fira Code','Consolas',monospace!important;
  font-size:13px!important;line-height:1.6!important;
  border-radius:10px;resize:vertical
}

.ht-preview{background:#fff;border:1px solid #e4e7ed;border-radius:10px;padding:16px 20px;min-height:100px}
.ht-preview-title{font-size:12px;font-weight:700;color:#909399;margin-bottom:8px}

.fmt-status-bar{font-size:12px}
.fmt-hint{color:#c0c4cc}
</style>
